import { UserPathCardData } from "../../models/app-data-model";
import { getContentHubDamAsset } from "../../../shared/utils/get-contenthub-dam-asset";
import React from 'react';
import './UserPathCard.scss';
import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export type UserPathCardProps = {
  user_path_card: UserPathCardData;
};

const UserPathCard: React.FC<UserPathCardProps> = ({ user_path_card }: UserPathCardProps) => {
  const url = user_path_card.reference[0]?.url || getContentHubDamAsset(user_path_card.reference[0]?.contenthub_asset)?.url || '';

  return (
      <Card className="upg-card">
        <CardActionArea href={url}>
        <CardContent className="upg-card-content">
            <h4>{user_path_card?.headline}</h4>
            <div className="upg-card-content-description">
              <Typography variant="body2">{user_path_card?.short_description}</Typography>
              <ArrowForwardIosIcon></ArrowForwardIosIcon>
            </div>
        </CardContent>
        </CardActionArea>
      </Card>
  );
};

export default UserPathCard;
